import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { WhiteLabelService } from '../services/white-label.service';

@Injectable()
export class SuperAdminRol implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private whiteLabelService: WhiteLabelService,
  ) {}

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    const user = this.authService.getUser();
    if (!user) {
      this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
      return false;
    }
    const isSuperAdmin = user.roles.indexOf('superAdmin') > -1;
    if (isSuperAdmin) return true;
    else false;
  }
}
